<template>
  <div class="training-page" :class="[$config.project]">
    <div
      class="hero-section"
      :style="$store.state.layout !== 'mobile' || $store.state.tablet ? { backgroundImage: `url(${getLargeImage(info.primaryImage)})` } : {}"
    >
      <div
        v-if="$store.state.layout === 'mobile' && !$store.state.tablet"
        class="bg-image"
        :style="{ backgroundImage: `url(${getLargeImage(info.primaryImage)})` }"
      />
      <div class="container">
        <div class="row">
          <div class="col" :class="[$config.project === 'site' ? 'col-4' : 'col-6']">
            <p class="highlight">
              Learn <span>LIVE</span> with
            </p>
            <h1 :class="[$config.project === 'site' ? 'h2' : 'h3']">
              {{ info.author }}
            </h1>
            <h2 class="h5">
              {{ info.title }}
            </h2>
            <p class="instructor-descr">
              {{ info.shortDescription }}
            </p>
            <div v-if="$config.project === 'site'" class="info">
              <div>
                <div class="duration">
                  <IconClock /> {{ info.duration }}
                </div>
                <div class="difficulty">
                  <component :is="require(`../../assets/svg/icon-difficulty-${info.difficulty.toLowerCase()}-2.svg?vue-component`)" />  {{ info.difficulty }}
                </div>
              </div>
              <div>
                <div class="lang">
                  <IconLanguage /> English
                </div>
                <div class="certificate">
                  <IconCertificate /> Certificate
                </div>
              </div>
            </div>
            <div v-else-if="$config.project === 'lms'" class="info">
              <div>
                <div class="duration">
                  <IconClock /> {{ info.duration }}
                </div>
                <div>
                  <IconPrice /> {{ info.price }}
                </div>
              </div>
              <div>
                <div class="difficulty">
                  <component :is="require(`../../assets/svg/icon-difficulty-${info.difficulty.toLowerCase()}-2.svg?vue-component`)" />  {{ info.difficulty }}
                </div>
                <div class="lang">
                  <IconLanguage /> English
                </div>
              </div>
              <div>
                <div class="certificate">
                  <IconCertificate /> Certificate
                </div>
              </div>
            </div>
            <!-- <div v-if="$config.project === 'lms'" class="price">
              From <span>{{ info.price }}</span>/{{ Math.ceil(info.duration / 24 ) }} days
            </div>
            <div class="info">
              <span class="body-2">
                {{ info.duration }} hours
              </span>
              <li>
                <span class="body-2">
                  {{ info.difficulty }}
                </span>
              </li>
            </div> -->
            <div class="footer col-9">
              <nuxt-link v-if="$config.project === 'site'" to="/live-trainings/signup/" class="btn-primary btn-lg">
                Sign Up
              </nuxt-link>
              <template v-else>
                <button class="btn-primary" @click="$emit('scrollToLastSection')">
                  Apply now
                </button>
                <div class="note">
                  One-time payment
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="section description">
      <div class="container">
        <div :class="$config.project === 'site' ? 'col-10 offset-1' : 'col-12'">
          <h3 :class="$config.project === 'site' ? 'h3' : 'h5'">
            {{ info.sectionTitle }}
          </h3>
          <p class="body-2" v-html="info.description" />
        </div>
      </div>
    </div>
    <div v-if="info.video" class="section video-holder">
      <div class="container">
        <div class="col-10 offset-1">
          <slot name="player" />
        </div>
      </div>
    </div>
    <div class="section benefits">
      <div class="container">
        <div class="row">
          <div class="col">
            <h4 class="title" :class="$config.project === 'site' ? 'h3' : 'h5'">
              {{ info.benefitsTitle }}
            </h4>
            <div class="row">
              <div v-for="(b, i) in getList('benefits')" :key="i" class="col-4 col">
                <div class="card">
                  <h5 class="h5">
                    {{ b.title }}
                  </h5>
                  <p class="body-2">
                    {{ b.description }}
                  </p>
                </div>
              </div>
            </div>
            <nuxt-link v-if="$config.project === 'site'" to="/live-trainings/signup/" class="btn-primary btn-lg">
              Sign Up
            </nuxt-link>
            <button v-else class="btn-primary" @click="$emit('scrollToLastSection')">
              Apply now
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="section quote">
      <div class="quote-holder">
        <div class="container">
          <div class="row">
            <div :class="$config.project === 'site' ? 'col-10 col offset-1' : 'col-12'">
              <IconQuote />
              <div class="info">
                {{ info.quote }}
              </div>
              <p class="h4">
                {{ info.author }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="section audience">
      <div class="container">
        <div class="row">
          <div class="col">
            <h3 class="title" :class="[$config.project === 'site' ? 'h3' : 'h5']">
              Who Is This Course For
            </h3>
            <div class="row">
              <div v-for="(b, i) in info.targetAudience" :key="i" class="col-4 col">
                <div class="card">
                  <Component :is="getAudienceIcon(i)" />
                  <p class="title" :class="[$config.project === 'site' ? 'blog-post-title-4' : 'h6']">
                    {{ b }}
                  </p>
                  <p class="body-2">
                    {{ targetAudiences[b] }}
                  </p>
                </div>
              </div>
            </div>
            <div class="difficulty">
              <div class="heading">
                <p class="title" :class="[$config.project === 'site' ? 'h4' : 'h5']">
                  Level Of Difficulty
                </p>
                <span> <component :is="require(`../../assets/svg/icon-difficulty-${info.difficulty.toLowerCase()}.svg?vue-component`)" /> {{ info.difficulty }} </span>
              </div>
              <div class="body-2">
                <template v-if="info.difficulty === 'Beginner'">
                  <strong>{{ info.title }}</strong> is a beginner-level training with no prerequisites. All professionals, regardless of their background, experience, and current skill level are welcome to join without any self-preparation in advance.
                </template>
                <template v-else-if="info.difficulty === 'Intermediate'">
                  <strong>{{ info.title }}</strong> is an intermediate-level training that requires familiarity with the topic. Professionals who lack relevant knowledge are encouraged to dedicate some time to self-preparation before the event to build the necessary foundation. Contact us to discuss in detail if the training is suitable for your team.
                </template>
                <template v-else-if="info.difficulty === 'Advanced'">
                  <strong>{{ info.title }}</strong> is an advanced-level training that requires specific working knowledge on the topic. Professionals who lack relevant background and experience are encouraged to dedicate considerable time to self-preparation before the event to meet the necessary prerequisites. Contact us to discuss in detail if the training is suitable for your team.
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="section author">
      <div class="container">
        <div class="row">
          <div :class="$config.project === 'site' ? 'col-10 col offset-1' : 'col-12'">
            <div v-for="(instructor, k) in info.instructors" :key="k" class="meet-author">
              <div class="image-holder col-5 col">
                <img loading="lazy" :src="`${$config.imagesUrl}/team/thumb@360_${instructor.image}`" :alt="instructor.name">
                <span v-if="$store.state.layout === 'desktop'">
                  <ButtonArrow
                    v-if="instructor.linkedin"
                    type="a"
                    :href="instructor.linkedin"
                    text="See LinkedIn profile"
                    target="_blank"
                    class="linkedin"
                  />
                </span>
              </div>
              <div class="info col-6 col offset-1">
                <h3 class="title" :class="[$config.project === 'site' ? 'h3' : 'h5']">
                  Meet {{ instructor.name }}
                </h3>
                <p :class="[$config.project === 'site' ? 'body-2' : '']">
                  {{ instructor.instructorShortDescription }}
                </p>
                <div class="stats">
                  <div class="text">
                    {{ instructor.signature1 }}
                  </div>
                  <div v-if="instructor.signature2" class="text">
                    {{ instructor.signature2 }}
                  </div>
                  <div v-if="instructor.signature3" class="text">
                    {{ instructor.signature3 }}
                  </div>
                </div>
                <span v-if="$store.state.layout === 'mobile'">
                  <ButtonArrow
                    v-if="instructor.linkedin"
                    type="a"
                    :href="instructor.linkedin"
                    text="See LinkedIn profile"
                    target="_blank"
                    class="linkedin"
                  />
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="section learn">
      <div class="container">
        <div class="row">
          <div class="col">
            <h4 class="title" :class="[$config.project === 'site' ? 'h3' : 'h5']">
              {{ info.learnTitle }}
            </h4>
            <ul>
              <li v-for="(l, idx) in getList('learn')" :key="idx" class="body-2">
                {{ l }}
              </li>
            </ul>
            <div class="button-holder">
              <nuxt-link v-if="$config.project === 'site'" to="/live-trainings/signup/" class="btn-primary btn-lg">
                Sign Up
              </nuxt-link>
              <button v-else class="btn-primary" @click="$emit('scrollToLastSection')">
                Apply now
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="section curriculum">
      <div class="container">
        <div :class="$config.project === 'site' ? 'col-10 offset-1' : 'col-12'">
          <div class="program">
            <div class="heading">
              <h4 class="title h3" :class="[$config.project === 'site' ? 'h3' : 'h5']">
                Curriculum
              </h4>
              <div class="info">
                <li>
                  <span class="body-2">
                    {{ curriculumDuration }}
                  </span>
                </li>
              </div>
            </div>
            <div class="list" :class="{ 'open': seeMore }">
              <template v-for="section in getList('curriculum').list">
                <div v-for="(l, id) in section" :key="id" class="day">
                  <div class="day-title">
                    <h5 class="h6">
                      {{ l.name }}
                      <span>
                        {{ l.duration }} min
                      </span>
                    </h5>
                  </div>
                  <div v-for="(lesson, i) in l.list" :key="i">
                    <p class="body-2">
                      {{ lesson.title }}
                    </p>
                  </div>
                </div>
              </template>
            </div>
            <div class="see-more" @click="seeMore = !seeMore">
              {{ seeMore ? 'See Less' : 'See More' }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="section faq">
      <div class="container">
        <div class="row">
          <div class="faq-holder" :class="$config.project === 'site' ? 'col-10 offset-1' : 'col-12'">
            <h4 class="title" :class="[$config.project === 'site' ? 'h3' : 'h5']">
              Frequently Asked Questions
            </h4>
            <div class="questions">
              <div v-for="(group, idx) in dataStructure()" :key="idx" class="col-6 col">
                <div
                  v-for="(qa, i) in group" :key="i" class="qa-holder"
                  :class="{ 'expanded': qa.expanded }"
                >
                  <div class="heading" @click="toggleFAQ(i)">
                    <h5 class="h4">
                      {{ qa.question }}
                    </h5>
                    <IconExpand />
                  </div>
                  <p class="body-1" v-html="qa.answer" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <slot name="get-access" />
    <slot name="slider" />
    <div
      v-if="$config.project === 'lms'"
      class="request-training hero-section"
      :style="$store.state.layout !== 'mobile' || $store.state.tablet ? { backgroundImage: `url(${getLargeImage(info.secondaryImage)})` } : {}"
    >
      <div class="container">
        <div class="col col-5">
          <slot name="request-training" />
        </div>
      </div>
      <div class="img-mobile">
        <img v-if="$store.state.layout === 'mobile' && !$store.state.tablet" :src="getLargeImage(info.secondaryImage)">
      </div>
    </div>
  </div>
</template>

<script>
import ButtonArrow from '../../components/ButtonArrow';
import IconQuote from '../../assets/svg/icon-quote.svg?vue-component';
import IconExpand from '../../assets/svg/icon-faq-expand.svg?vue-component';
import IconClock from '../../assets/svg/icon-clock.svg?vue-component';
import IconLanguage from '../../assets/svg/icon-language.svg?vue-component';
import IconCertificate from '../../assets/svg/icon-certificate.svg?vue-component';
import IconPrice from '../../assets/svg/icon-price.svg?vue-component';

/* eslint-disable global-require */
/* eslint-disable import/no-dynamic-require */
export default {
  components: {
    ButtonArrow,
    IconQuote,
    IconExpand,
    IconClock,
    IconLanguage,
    IconCertificate,
    IconPrice,
  },
  props: {
    info: { type: Object, default: () => {}, required: true },
  },
  data() {
    return {
      seeMore: false,
    };
  },
  computed: {
    targetAudiences() {
      return {
        'Business Leaders': 'You take organizations to new heights of prosperity with top-notch leadership and practical data skills',
        'Project Managers': 'You want to enhance your managerial skills and oversee projects from conception all the way to completion',
        'Data Scientists': 'You assist businesses with their decision-making using your analytical, and data storytelling skills',
        'Data Engineers': 'You seek to build data systems that help organizations make sense of raw data and generate actionable insights',
        'ML Engineers': 'You aim to utilize advanced machine learning algorithms to build highly accurate predictive models',
        'AI Practitioners': 'As an AI experts, you seek to implement state-of-the-art algorithms and fine- tune AI solutions to enhance business performance',
        'Business Analysts': 'You guide organizations into adopting data-driven strategies that optimize business processes and functions',
        'Marketing Experts': 'You strive to develop long-term marketing strategies that boost revenue growth and company reputation',
        'Computer Engineers': 'You design computer systems that maximize system operations and build upon competitive strengths',
      };
    },
    curriculumDuration() {
      const { duration } = this.getList('curriculum');

      const hrs = Math.floor(duration / 60);
      const min = Math.floor(duration % 60);

      return `${hrs} hours ${min ? `${min} min` : ''}`;
    },
  },
  methods: {
    getLargeImage(img) {
      return this.$webp(`${this.$config.imagesUrl}/live-trainings/${img}`) || '';
    },
    getList(o) {
      return JSON.parse(`${this.info[o]}`) || {};
    },
    getAudienceIcon(i) {
      return require(`../../assets/svg/icon-audience-${i + 1}.svg?vue-component`);
    },
    dataStructure() {
      const cols = this.$store.state.layout === 'desktop' ? 2 : 1;
      const data = this.info.faq || {};

      const chunkSize = Math.ceil(data.length / cols);
      const dataArray = [];
      for (let i = 0; i < data.length; i += 1) {
        const chunkIndex = Math.floor(i / chunkSize);

        if (!dataArray[chunkIndex]) {
          dataArray[chunkIndex] = [];
        }

        dataArray[chunkIndex].push(data[i]);
      }
      for (let i = 0; i < dataArray.length; i += 1) {
        dataArray[i] = [...dataArray[i]];
      }

      return dataArray;
    },
    toggleFAQ(id) {
      if (this.$store.state.layout === 'desktop' || this.$config.project === 'lms') {
        return;
      }
      this.faq[id].expanded = !this.faq[id].expanded;
    },
  },
};
</script>

<style lang="scss">
.training-page {
  &.lms {
    .hero-section {
      height: 544px;

      .h5 {
        font-weight: 600;
      }

      .instructor-descr {
        font-weight: 500;
      }

      .price {
        margin-bottom: var(--spacing-4);
        line-height: 100%;

        span {
          font-size: 21px;
        }
      }

      // .info {
      //   color: var(--main-light-shade-4);

      //   .body-2 {
      //     font-size: 14px;
      //     font-weight: 500;
      //   }
      // }

      .footer {
        display: inline-flex;
        flex-direction: column;
        justify-content: center;

        .btn-primary {
          width: 203px;
          padding-top: 15px;
          padding-bottom: 15px;
        }
      }

      .note {
        font-size: 12px;
        color: var(--main-light-shade-4);
        margin-top: 1px;
      }
    }

    .section {
      padding: 120px 0;
    }

    .description {
      .h3,
      .h5 {
        font-weight: 600;
      }
    }

    .benefits {
      .title {
        font-weight: 600;
      }

      .card {
        border-radius: 20px;

        > .title {
          font-weight: 500;
          font-size: 18px;
        }
      }

      .btn-primary {
        width: 203px;
        padding-top: 15px;
        padding-bottom: 15px;
      }
    }

    .quote {
      .h4 {
        font-size: 18px;
        font-weight: 500;
      }
    }

    .audience {
      .title {
        font-weight: 600;
      }

      .card {
        .body-2 {
          max-width: 312px;
          text-align: center;
          margin: 0 auto;
        }
      }

      .col-3:first-of-type {
        margin-left: 0;
      }

      .difficulty {
        margin-top: 52px;
        border-radius: 20px;
        box-shadow: 0 16px 30px rgba(0, 12, 31, 0.08);

        .h5 {
          font-weight: 600;

          &.title {
            margin-bottom: 0;
            margin-right: var(--spacing-12);
          }
        }

        .body-2 {
          line-height: 27px;
        }
      }
    }

    .author {
      background-color: transparent;

      .meet-author {
        .linkedin {
          color: var(--accent);
        }

        .info {
          .title {
            margin-bottom: 42px;
          }
        }
      }
    }

    .learn {
      .btn-primary {
        max-width: 203px;
        padding: 15px;
      }
    }

    .curriculum {
      .program {
        border-radius: 20px;

        .list {
          .day {
            .day-title {
              li {
                margin-left: var(--spacing-8);
                list-style: none;

                span {
                  position: relative;
                  left: -6px;
                  font-size: 18px;
                  font-weight: 600;
                  color: var(--main-dark-light-4);
                }
              }
            }

            .h6 {
              font-size: 18px;
              font-weight: 600;
              line-height: var(--base-line-height);
            }
          }
        }

        .see-more {
          font-size: 16px;
        }
      }
    }

    .faq {
      .faq-holder {
        .title {
          font-size: 18px;
          font-weight: 500;
        }

        .questions {
          > div:first-of-type {
            padding-right: var(--spacing-28);
          }

          > div:last-of-type {
            padding-left: var(--spacing-28);
          }

          .body-1 {
            font-size: 16px;
            line-height: 27px;
            color: var(--main-dark-light-4);
          }
        }
      }
    }

    .request-training {
      display: flex;
      align-items: center;
      height: auto;
      min-height: 650px;
      padding-top: 19px;
      padding-bottom: 19px;

      &:before {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        height: 100%;
        width: 100%;
        background: linear-gradient(106.99deg, rgba(86, 191, 199, 0.2) 10.8%, rgba(86, 191, 199, 0) 61.7%);
      }

      select,
      textarea {
        font-size: 14px;

        &::placeholder {
          font-size: 14px;
        }
      }

      .col-5 {
        padding: 0;
      }
    }
  }

  &.site {
    .author {
      .meet-author {
        .linkedin {
          font-size: 18px;
          color: var(--accent-shade-1);
        }
      }
    }

    .section.learn {
      padding-top: 140px !important;
    }
  }

  .hero-section {
    height: 650px;
    position: relative;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    background-color: var(--main-dark);
    image-rendering: -webkit-optimize-contrast;

    .container {
      position: relative;
      height: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      z-index: 2;
      color: var(--main-light);

      .row {
        width: 100%;
      }
    }

    .highlight {
      font-size: 21px;
      font-weight: 500;
      margin: 0;

      span {
        font-weight: 600;
        color: var(--accent);
      }
    }

    .h2,
    .h3 {
      margin: var(--spacing-8) 0;
    }

    .h5 {
      color: var(--main-light-shade-3);
    }

    .instructor-descr {
      margin: var(--spacing-36) 0;
      color: var(--main-light-shade-4);
      font-size: 14px;
    }

    .info {
      margin-bottom: var(--spacing-36);
      color: var(--main-light);

      div {
        div {
          display: flex;
          align-items: center;

          &:not(:last-child) {
            margin-bottom: 8px;
          }
        }

        svg {
          margin-right: 12px;
        }
      }

      > div {
        flex-direction: column;
        align-items: flex-start;
        display: inline-flex;

        &:not(:last-child) {
          margin-right: 50px;
        }
      }

      li {
        margin-left: var(--spacing-8);

        span {
          position: relative;
          font-size: 18px;
        }
      }
    }

    .footer {
      .btn-primary {
        width: 100%;
        max-width: 300px;
      }
    }
  }

  .section {
    padding: 140px 0;
    background-color: var(--main-light-shade-1);

    & + .section {
      padding-top: 0 !important;
    }
  }

  .description {
    .h3,
    .h5 {
      max-width: 570px;
      margin: 0 auto;
      text-align: center;
    }
  }

  .benefits {
    text-align: center;

    .title {
      margin-bottom: var(--spacing-36);
    }

    .card {
      background-color: var(--main-light-shade-2);
      border-radius: 10px;
      padding: var(--spacing-40) var(--spacing-32);
      height: 100%;

      .body-2 {
        color: var(--main-dark-light-4);
      }
    }

    .btn-primary {
      width: 100%;
      max-width: 305px;
      margin-top: var(--spacing-36);
    }
  }

  .quote {
    color: var(--main-dark-light-4);

    .quote-holder {
      padding: var(--spacing-80) 0;
      background-color: var(--main-light-shade-2);

      svg path {
        fill: var(--accent-shade-1);
      }
    }

    .info {
      margin-top: var(--spacing-16);
      padding-left: 19px;
      border-left: 1px solid var(--main-light-shade-4);
      font-size: 21px;
      line-height: 150%;
    }

    .h4 {
      margin-top: 19px;
      margin-bottom: 0;
      padding-left: 19px;
      color: var(--main-dark-light-4);
      font-size: 24px;
    }
  }

  .audience {
    .title {
      text-align: center;
      margin-bottom: var(--spacing-36);
    }

    .card {
      height: 100%;
      text-align: center;

      .title {
        margin-top: var(--spacing-20);
        font-weight: 500;
      }

      .body-2 {
        margin: 0;
        color: var(--main-dark-light-4);
      }
    }

    .difficulty {
      margin-top: var(--spacing-36);
      padding: var(--spacing-32);
      background-color: var(--main-light);
      box-shadow: 0 3px 8px rgba(0, 12, 31, 0.05);
      border-radius: 10px;

      .heading {
        display: flex;
        align-items: center;
      }

      .h4 {
        margin: 0 var(--spacing-12) 0 0;
      }

      span {
        padding: 7px 16px;
        background-color: var(--main-dark);
        color: var(--main-light);
        border-radius: 100px;
        display: flex;
        align-items: center;

        svg {
          margin-right: 8px;
        }
      }

      .body-2 {
        margin-top: var(--spacing-16);
        color: var(--main-dark-light-4);
      }
    }
  }

  .author {
    background-color: var(--main-light-shade-2);
    padding-bottom: 0;

    .meet-author {
      display: flex;
      padding: var(--spacing-120) 0;

      &:nth-child(n + 2) {
        padding-top: 0;
      }

      .image-holder {
        display: flex;
        flex-direction: column;
        // margin-right: 130px;
      }

      img {
        max-height: 300px;
        border-radius: 10px;
      }

      .linkedin {
        margin-top: var(--spacing-24);
      }

      .info {
        .title {
          margin-bottom: var(--spacing-32);
        }

        p {
          &:first-of-type {
            margin-top: 0;
          }

          &:last-of-type {
            margin-bottom: 0;
          }
        }

        .stats {
          margin-top: var(--spacing-32);

          div {
            color: var(--main-dark-light-4);
            font-size: 18px;
            font-weight: 600;
            display: inline-block;
            margin-bottom: 12px;

            &:not(:last-child):after {
              content: "|";
              margin: 0 18px;
            }
          }
        }
      }
    }
  }

  .learn {
    .title {
      text-align: center;
      margin-bottom: var(--spacing-36);
    }

    ul {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      column-gap: var(--spacing-30);
      margin-bottom: var(--spacing-36);
      list-style: none;
      padding: 0;

      li {
        margin-bottom: var(--spacing-24);
        background-image: url('../../assets/svg/icon-check-list.svg');
        image-rendering: -webkit-optimize-contrast;
        background-repeat: no-repeat;
        padding-left: var(--spacing-30);
      }
    }

    .button-holder {
      text-align: center;
    }

    .btn-primary {
      width: 100%;
      max-width: 300px;
    }
  }

  .curriculum {
    .program {
      padding: 54px 44px;
      background-color: var(--main-light);
      border: 1px solid var(--main-light-shade-2);
      border-radius: 10px;
      filter: drop-shadow(0 16px 30px rgba(0, 12, 31, 0.08));

      .heading {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: var(--spacing-32);
      }

      .title {
        margin: 0;
      }

      .info {
        display: flex;
        font-size: 14px;

        span {
          color: var(--main-dark-light-3);
        }

        li {
          margin-left: var(--spacing-8);
          list-style: none;

          span {
            position: relative;
            left: -6px;
          }
        }
      }

      .list {
        max-height: 450px;
        overflow: hidden;
        transition: all var(--duration) ease;
        position: relative;

        &:before {
          content: '';
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 87px;
          background: linear-gradient(0deg, #FFF -12.31%, rgba(255, 255, 255, 0.94) 51.45%, rgba(255, 255, 255, 0) 100%);
          transition: all var(--duration) ease;
          transform: matrix(-1, 0, 0, 1, 0, 0);
        }

        &.open {
          max-height: 5000px;

          &:before {
            height: 0;
          }
        }

        .day {
          &:not(:last-of-type) {
            padding-bottom: var(--spacing-24);
            margin-bottom: var(--spacing-24);
            border-bottom: 1px solid var(--main-light-shade-2);
          }

          .h6 {
            margin: 0;
            padding-left: 4px;
            display: flex;
            align-items: center;

            span {
              color: var(--main-dark-light-4);
              font-size: 16px;
              font-weight: 400;
              margin-left: auto;
            }
          }

          .day-title {
            margin-bottom: 8px;
          }

          div:not(.day-title) {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: var(--spacing-8) 0;

            p {
              margin: 0;
              color: var(--main-dark-light-2);

              &:before {
                content: "\2022";
                color: var(--accent-light-3);
                font-weight: bold;
                margin-right: 12px;
                margin-left: 32px;
                font-size: 21px;
              }
            }

            .caption {
              flex: 0 0 auto;
              margin-left: var(--spacing-8);
              color: var(--main-dark-light-3);
            }
          }
        }
      }

      .see-more {
        margin-top: 14px;
        color: var(--accent);
        font-size: 18px;
        font-weight: 600;
        cursor: pointer;
      }
    }
  }

  .faq {
    .faq-holder {
      .heading {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: var(--spacing-16);
      }

      .h4 {
        margin: 0;
      }

      svg {
        display: none;
        margin-left: var(--spacing-18);
        flex: 0 0 auto;

        path[stroke] {
          stroke: var(--main-dark);
        }
      }

      .title {
        max-width: 370px;
        margin-bottom: var(--spacing-60);
        margin-left: 15px;
      }

      .questions {
        display: flex;
        flex-wrap: wrap;

        .qa-holder {
          margin-bottom: var(--spacing-60);

          &.expanded {
            svg {
              transform: rotate(90deg);
            }
          }
        }

        .body-1 {
          margin: 0;
          color: var(--main-dark-light-3);
        }

        &.expanded {
          .body-1 {
            max-height: 9999px;
            transition: max-height 1s ease-in-out;
            overflow: hidden;
          }
        }
      }
    }
  }
}

@include bp($bp-laptop) {
  .training-page {
    .benefits .btn-primary {
      width: 225px;
    }

    .faq .faq-holder {
      .heading {
        .h4 {
          font-weight: 500;
          font-size: 24px;
          line-height: 110%;
        }
      }

      .title {
        font-size: 24px;
      }
    }
  }
}

@include bp($bp-mobile) {
  .training-page {
    &.lms {
      .section {
        padding: var(--spacing-80) 0;
      }

      .benefits {
        .title {
          font-size: 21px;
        }

        .card {
          border-radius: 10px;
        }

        .btn-primary {
          width: 100%;
          padding-top: 17px;
          padding-bottom: 17px;
        }
      }

      .quote {
        .info {
          font-size: 18px;
        }

        .h4 {
          margin-top: 0;
          padding-top: 19px;
          border-left: 1px solid var(--main-light-shade-4);
          font-weight: 600;
        }
      }

      .audience {
        .title {
          font-size: 21px;
        }

        .card {
          .body-2 {
            max-width: 100%;
          }
        }

        .col:not(:last-of-type) {
          margin-bottom: var(--spacing-40);
        }
      }

      .author {
        .meet-author {
          .image-holder {
            margin-bottom: var(--spacing-32);
          }

          .info {
            .title {
              margin-bottom: var(--spacing-36);
            }

            .stats {
              margin-top: var(--spacing-36);
            }
          }
        }
      }

      .learn {
        .title {
          margin-bottom: var(--spacing-24);
          font-size: 21px;
        }

        ul {
          margin-bottom: var(--spacing-24);

          li {
            margin-bottom: var(--spacing-18);
          }
        }

        .btn-primary {
          max-width: 328px;
        }
      }

      .curriculum {
        .program {
          border-radius: 0;
          padding: 32px 44px;

          .see-more {
            text-align: left;
          }
        }
      }

      .faq {
        .faq-holder {
          .title {
            font-size: 21px;
            line-height: 25.6px;
          }

          .questions {
            > div:first-of-type {
              padding-right: 0;
            }

            > div:last-of-type {
              padding-left: 0;
            }
          }
        }
      }

      .request-training {
        padding-top: 38px;
        padding-bottom: 38px;
      }
    }

    &.site {
      .faq {
        .faq-holder {
          .title {
            margin-bottom: var(--spacing-18);
          }

          .heading {
            cursor: pointer;
          }

          .h4 {
            font-size: 16px;
          }

          svg {
            display: block;
          }

          .questions {
            > div:first-of-type {
              padding-right: 0;
            }

            > div:last-of-type {
              padding-left: 0;
            }

            .qa-holder {
              padding: var(--spacing-18) 0;
              margin-bottom: 0;

              &:not(:last-of-type) {
                border-bottom: 1px solid rgba(0, 12, 31, 0.12);
              }

              .body-1 {
                max-height: 0;
                overflow: hidden;
                transition: all 500ms cubic-bezier(0, 1, 0, 1);
              }

              &.expanded {
                .body-1 {
                  max-height: 9999px;
                  transition: max-height 1s ease-in-out;
                  overflow: hidden;
                }
              }
            }
          }
        }
      }
    }

    .section {
      padding: var(--spacing-80) 0;
    }

    .hero-section {
      background-position: 65%;
      position: relative;

      &:after {
        content: '';
        position: absolute;
        top: 0;
        height: 100%;
        width: 50%;
        background: linear-gradient(90deg, rgba(0, 12, 31, 0.94) 0%, var(--main-dark) 0.01%, rgba(0, 12, 31, 0.98) 56.77%, rgba(0, 12, 31, 0) 100%);
      }

      .instructor-descr {
        max-width: 50%;
      }

      .info > div:nth-child(3) {
        margin-top: 8px;
      }

      .footer .btn-primary {
        max-width: 344px;
      }

      .container {
        .row {
          width: unset;
        }
      }
    }

    .benefits {
      .title {
        font-size: 24px;
      }

      .col-4:not(:last-of-type) {
        margin-bottom: 17px;
      }

      .card {
        min-height: 238px;
      }

      .btn-primary {
        max-width: 328px;
      }
    }

    .quote {
      .h4 {
        font-size: 24px;
      }
    }

    .audience {
      .title {
        font-size: 24px;
      }

      .col:not(:last-of-type) {
        margin-bottom: 17px;
      }

      .difficulty {
        margin-top: var(--spacing-80) !important;

        .heading {
          flex-direction: column;
          align-items: flex-start;
        }

        .title {
          margin: 0 0 var(--spacing-12);

          &.h4 {
            font-size: 24px;
          }
        }
      }
    }

    .author {
      .meet-author {
        flex-direction: column;
        align-items: flex-start;
        padding: var(--spacing-80) 0;

        .image-holder {
          margin: 0 0 var(--spacing-40);
        }

        img {
          max-width: 100%;
          object-fit: contain;
        }

        .info {
          .title {
            margin-bottom: var(--spacing-36);
          }

          .stats {
            flex-direction: column;
            align-items: flex-start;
            margin-top: var(--spacing-36);

            .stat:first-of-type {
              margin: 0 0 var(--spacing-36);
            }
          }
        }

        .linkedin {
          margin-top: var(--spacing-40);
        }
      }
    }

    .learn {
      .title,
      .button-holder {
        text-align: left;
      }

      .title {
        font-size: 24px;
        margin-bottom: var(--spacing-40);
      }

      ul {
        grid-template-columns: 1fr;
        margin-bottom: var(--spacing-40);

        li {
          margin-bottom: 28px;
        }
      }

      .btn-primary {
        max-width: 328px;
      }
    }

    .curriculum {
      .program {
        margin-left: -24px;
        margin-right: -24px;
        padding: 54px 24px;
        border-radius: 0;

        .h3 {
          font-size: 24px;
        }

        .list {
          max-height: 550px;
        }

        .see-more {
          text-align: center;
        }
      }
    }
  }
}

@include bp($bp-phone) {
  .training-page {
    &.lms {
      .hero-section {
        height: auto;
        min-height: 748px;

        &:before {
          height: 250px;
        }

        .bg-image {
          background-position: 75% -20%;
          image-rendering: -webkit-optimize-contrast;
        }

        .container {
          padding-top: 250px;
        }

        .h5 {
          margin-bottom: var(--spacing-12);
        }

        .instructor-descr {
          font-size: 14px;
          margin: var(--spacing-12) 0 var(--spacing-32);
        }

        .info {
          margin-bottom: var(--spacing-32);
        }

        .footer {
          display: flex;

          .btn-primary {
            width: 100%;
            padding-top: 17px;
            padding-bottom: 17px;
          }
        }
      }

      .request-training {
        display: block;
        padding: 0;

        &:before {
          display: none;
        }

        &:after {
          background: linear-gradient(90deg, var(--main-dark) -25.26%, rgba(0, 12, 31, 0) 15.79%, rgba(0, 12, 31, 0) 87.19%, var(--main-dark) 123.24%), linear-gradient(180deg, var(--main-dark) 58.46%, rgba(0, 12, 31, 0) 66.86%, rgba(0, 12, 31, 0) 90.66%, var(--main-dark) 108.06%);
          z-index: -1;
        }

        .container {
          padding-top: 49px;
          background: var(--main-dark);
        }

        .img-mobile {
          right: 0;
          bottom: 0;
          height: 450px;
          width: 100%;
          overflow: hidden;
          z-index: 0;

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            object-position: 75%;
          }
        }
      }
    }

    .hero-section {
      background: none !important;
      height: auto;
      overflow: hidden;

      .bg-image {
        height: 100%;
        width: 100%;
        background-repeat: no-repeat;
        background-size: auto 500px;
        background-position: 75% 0;
        background-color: var(--main-dark);
        position: absolute;
        top: 0;
        left: 0;
      }

      .container {
        padding: var(--spacing-48) var(--spacing-24);
        padding-top: 400px;
      }

      h1 {
        font-size: 28px;
      }

      .instructor-descr {
        font-size: 16px;
        max-width: 100%;
      }

      &:after {
        content: '';
        position: absolute;
        top: unset;
        bottom: 0;
        width: 100%;
        height: 100%;
        background: linear-gradient(180deg, rgba(0, 12, 31, 0) 33.42%, var(--main-dark) 59.36%);
      }

      &:before {
        content: '';
        position: absolute;
        top: -210px;
        width: 100%;
        height: 360px;
        background: linear-gradient(180deg, var(--main-dark) 0%, rgba(0, 12, 31, 0.96) 70.77%, rgba(0, 12, 31, 0) 100%);
        z-index: 1;
      }
    }
  }
}
</style>
